import * as fromDatatype from "../datatype-library/index";

export interface alg_bot_cf_element_sequence_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
  conversation_flow_guid: fromDatatype.GuidDataFieldInterface;
  current_element_guid: fromDatatype.GuidDataFieldInterface;
  next_element_guid: fromDatatype.GuidDataFieldInterface;
  condition_json: fromDatatype.JsonDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class alg_bot_cf_element_sequence_RowClass implements alg_bot_cf_element_sequence_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
  conversation_flow_guid: fromDatatype.GuidDataFieldInterface;
  current_element_guid: fromDatatype.GuidDataFieldInterface;
  next_element_guid: fromDatatype.GuidDataFieldInterface;
  condition_json: fromDatatype.JsonDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
